import React, { Component } from 'react';
import SignUp from '../../client/components/signup';
import Header from '../../client/shared-ui/header/index';
//import { breakPoint_L } from '../../utility/breakPoints';

class SignUpPage extends Component {
  render () {
    // let Headers;
    // if(breakPoint_L==false) {
    //   Headers=<Header />;
    // }
    return (
      <>
        <Header />
        <SignUp />
      </>
    );
  }
}

export default SignUpPage;